import AgGridThemeClass from '@vendor/ag-grid/const/AgGridThemeClass';
import VcomProvider from '../../VcomProvider';

export default function agGridThemeClass() {
  return VcomProvider.Layout.getTheme() === 'mcflat' ? AgGridThemeClass.LIGHT : AgGridThemeClass.DARK;
}
